'use client';

import React from 'react';
import { v4 as uuid } from 'uuid';
import { CatCarouselItem } from 'components/blocks-components';
import { useBreakpoint } from 'components/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { ProductCardCarousel } from '../../../product-card/product-card-carousel';
import ProductComparisonGrid from 'components/product-comparison-grid';
import { createCarouselSlides } from '../utils';

export const ProductCardCarouselWrapper = ({ children, gridClassName }) => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const isXL = useBreakpoint(PAGE_BREAKPOINTS.XL);
  const childrenArray = React.Children.toArray(children);
  const itemsPerSlide = isXL ? 4 : 3;
  const isSingleSlide = childrenArray.length <= itemsPerSlide;

  if ((!isLG && isLG !== undefined) || isSingleSlide) {
    return (
      <ProductComparisonGrid classname={gridClassName}>
        {children}
      </ProductComparisonGrid>
    );
  }

  const slidesContent = createCarouselSlides(childrenArray, itemsPerSlide);
  return (
    <ProductCardCarousel>
      {slidesContent.map((slideItems) => (
        <CatCarouselItem key={uuid()}>
          <ProductComparisonGrid classname={gridClassName}>
            {slideItems}
          </ProductComparisonGrid>
        </CatCarouselItem>
      ))}
    </ProductCardCarousel>
  );
};
